import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    // Clear fragment immediately for cleanliness
    window.history.replaceState(null, '', window.location.pathname);

    (async () => {
      try {
        const res = await axios.post(
          `${API_URL}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setGoogleUser(res.data.user);
        toast.success('Connexion Google réussie !');
        navigate('/dashboard', { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error('Google auth failed:', e);
        toast.error('Échec de la connexion Google');
        navigate('/login', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-600">Connexion en cours...</p>
      </div>
    </div>
  );
};
